import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../context-store";
import Layout from "../../components/layout/Layout";
import "../../assets/InnerCSS/plugins/bootstrap/css/bootstrap.min.css";
import "../../assets/InnerCSS/plugins/font-awesome/css/font-awesome.min.css";
import "../../assets/InnerCSS/plugins/icomoon/style.css";
import "../../assets/InnerCSS/plugins/uniform/css/default.css";
import "../../assets/InnerCSS/plugins/switchery/switchery.min.css";
import "../../assets/InnerCSS/plugins/nvd3/nv.d3.min.css";
import "../../assets/InnerCSS/css/styles.css";
import "../../assets/InnerCSS/css/custom.css";
import AddProfilesComponent from "../../components/company/add-profiles/AddProfilesComponent";
import JobPostingParams from "../../models/common/PageParms";
import { useParams } from "react-router-dom";
import masterDataService from "../../services/master-data-service";
import addProfilesService from "../../services/company/add-profiles-service";
import IdNameModel from "../../models/common/IdNameModel";
import toasterUtils from "../../utils/toaster-utils";
import { ScreenEnum } from "../../models/enums/StatusEnum";
import jobPostingService from "../../services/company/job-posting-service";
import { useHistory } from "react-router";
import { RoleEnum } from "../../models/enums/RoleEnum";
import modalUtils from "../../utils/modal-utils";
import NavigateNextOutlinedIcon from '@mui/icons-material/NavigateNextOutlined';
import ViewEscalationComponent from "../../components/company/add-profiles/ViewEscalationComponent";
import { GeneralPoupConfig, ModalSize } from "../../models/modal-types";

const AddProfiles = () => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const history = useHistory();
    const requestParams: JobPostingParams = useParams();
    const [vendorList, setVendorList] = useState<IdNameModel[]>([]);
    const [statusList, setStatusList] = useState<IdNameModel[]>([]);
    const [refreshStatus, setRefreshStatus] = useState<number>(2);
    const [refreshVendors, setRefreshVendors] = useState<number>(2);
    const [jobCode, setJobCode] = useState<string>("");
    const [canScheduleInterviews, setCanScheduleInterviews] = useState<boolean>(false);
    const [refreshCanScheduleInterviews, setRefreshCanScheduleInterviews] = useState<number>(2);
    const [roleId, setRoleId] = useState<number>(loggedInUser !== null ? parseInt(loggedInUser.roleId) : 0);
    const [escalationStatusList, setEscalationStatusList] = useState<IdNameModel[]>([]);
    const [refreshEscalationStatus, setRefreshEscalationStatus] = useState<number>(2);

    useEffect(() => {
        if (loggedInUser) {
            getVendorList(loggedInUser?.profileId, requestParams.requirementId);
            getStatusList();
            getJobPosting(requestParams.requirementId);
            getEscalationStatusList();
        }
    }, []);

    const getJobPosting = (requirementId: string) => {
        modalUtils.showLoader();
        setRefreshCanScheduleInterviews(2);
        jobPostingService.getJobPostingById(requirementId).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setJobCode(res.data.jobCode);
            if (res.data.isCalibrationCallCompleted && res.data.isClientApproved && res.data.panelsAvailable) {
                setCanScheduleInterviews(true);
            }
            setRefreshCanScheduleInterviews(refreshCanScheduleInterviews * 5);
        }).catch((error) => {
            modalUtils.closeModal();
            setRefreshCanScheduleInterviews(refreshCanScheduleInterviews * 5);
            toasterUtils.showError(error);
        });
    };

    const getVendorList = (companyId: string, requirementId: string) => {
        setRefreshVendors(2);
        addProfilesService.fillVendorsForAddProfiles(companyId, requirementId).then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setVendorList(res.items);
            setRefreshVendors(refreshVendors * 5);
        }).catch((error) => {
            setRefreshVendors(refreshVendors * 5);
            toasterUtils.showError(error);
        });
    };

    const getStatusList = () => {
        setRefreshStatus(2);
        masterDataService.loadStatusByScreen(ScreenEnum.AddProfileStatus).then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setStatusList(res.items);
            setRefreshStatus(refreshStatus * 5);
        }).catch((error) => {
            setRefreshStatus(refreshStatus * 5);
            toasterUtils.showError(error);
        });
    };

    const getEscalationStatusList = () => {
        masterDataService.loadStatusByScreen(ScreenEnum.EscalationsStatus).then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setEscalationStatusList(res.items);
            setRefreshEscalationStatus(refreshEscalationStatus * 5);
        }).catch((error) => {
            setRefreshEscalationStatus(refreshEscalationStatus * 5);
            toasterUtils.showError(error);
        });
    };

    const onViewEscalationsHandler = (requirementId: string) => {
        const config: GeneralPoupConfig = {
            title: "Escalations",
            content: (
                <ViewEscalationComponent
                    requirementId={requirementId}
                    statusList={escalationStatusList} />
            ),
            size: ModalSize.XL,
            className: "model-min-height-500"
        };
        modalUtils.showPopup(config);
    };

    return (
        <Layout>
            <div className="breadcrumb-text">
                <a onClick={() => history.push("/")}>Home</a> <i className="fa-solid fa-angle-right"></i> <a onClick={() => history.push("/all-job-postings")}>Job Postings</a> <i className="fa-solid fa-angle-right"></i> Add Profiles
            </div>
            <div className="page-title">
                <h4 className="breadcrumb-header"> Add Profiles : <span>{jobCode}</span></h4>
            </div>

            {refreshStatus > 2 && refreshVendors > 2 && refreshCanScheduleInterviews > 2 && loggedInUser &&
                <AddProfilesComponent
                    vendorList={vendorList}
                    statusList={statusList}
                    requirementId={requestParams.requirementId}
                    profileId={loggedInUser.profileId}
                    userId={loggedInUser.userId}
                    canScheduleInterviews={canScheduleInterviews} />
            }
            <div className="row">
                {/* <div className="col-md-3">
                        <h4 className="job-code-header" >{jobCode}</h4>
                    </div> */}
                {(roleId === parseInt(RoleEnum.ClientRecruiter.toString()) || roleId === parseInt(RoleEnum.ClientAdmin.toString())) &&
                    <div className="email-actions col-md-9">
                        <a className="btn" onClick={() => history.push("/related-profiles/" + requestParams.requirementId)}><NavigateNextOutlinedIcon /> Related Candidate</a>
                        <a className="btn" onClick={() => history.push("/applied-candidates/" + requestParams.requirementId)}><NavigateNextOutlinedIcon /> Applied Candidate</a>
                        <a className="btn" onClick={() => history.push("/shortlisted-profiles/" + requestParams.requirementId)}><NavigateNextOutlinedIcon /> Shortlisted Candidate</a>
                        <a className="btn" onClick={() => onViewEscalationsHandler(requestParams.requirementId)}><NavigateNextOutlinedIcon /> Escalations</a>
                    </div>
                }
                {roleId === parseInt(RoleEnum.VendorRecruiter.toString()) &&
                    <div className="email-actions col-md-9">
                        <a className="btn" ><NavigateNextOutlinedIcon /> Related Candidate</a>
                        <a className="btn" ><NavigateNextOutlinedIcon /> Applied Candidate</a>
                        <a className="btn" ><NavigateNextOutlinedIcon /> Shortlisted Candidate</a>
                    </div>
                }
            </div>
        </Layout>
    );
};
export default AddProfiles;